module.exports = __webpack_public_path__ + "static/img/1.b050ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/doublelift/1.png
// module id = Gevo
// module chunks = 35